import { render, staticRenderFns } from "./CertificadosModalEmitir.vue?vue&type=template&id=4f99764d&"
import script from "./CertificadosModalEmitir.vue?vue&type=script&lang=ts&"
export * from "./CertificadosModalEmitir.vue?vue&type=script&lang=ts&"
import style0 from "./CertificadosModalEmitir.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports